/**
Author - Babajan
Git - https://www.github.com/babajanpatan
**/

import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";

const propTypes = {
  isReadingNewsletters: PropTypes.bool,
  setIsReadingFinished: PropTypes.func,
  target: PropTypes.any.isRequired
};

const ReadingProgressBar = ({
  target,
  setIsReadingFinished,
  isReadingNewsletters = false
}) => {
  const [barWidth, setBarWidth] = useState(0);

  const scrollListener = () => {
    if (!target.current) {
      return;
    }

    const element = target.current;
    const elementTop = element.getBoundingClientRect().top + window.scrollY;
    const elementHeight = element.clientHeight;
    const windowScrollTop = window.scrollY;

    const totalHeight = elementTop + elementHeight - window.innerHeight;

    if (windowScrollTop < elementTop) {
      setBarWidth(0);
      if (isReadingNewsletters) {
        setIsReadingFinished(false);
      }
    } else if (windowScrollTop > totalHeight) {
      setBarWidth(100);
      if (isReadingNewsletters) {
        setIsReadingFinished(true);
      }
    } else {
      const progress = ((windowScrollTop - elementTop) / (totalHeight - elementTop)) * 100;
      setBarWidth(progress);
      if (isReadingNewsletters) {
        setIsReadingFinished(false);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollListener);
    return () => window.removeEventListener("scroll", scrollListener);
  }, []);

  const barStyle = {
    position: "sticky",
    height: "7px",
    top: 0,
    backgroundColor: "#6725f4",
    width: `${barWidth}%`,
    zIndex: 10
  };

  return <div style={barStyle} />;
};

ReadingProgressBar.propTypes = propTypes;

export default ReadingProgressBar;
